import { createContext } from 'react';

/**
 * The left side of the top bar, where the current page draws its title (see
 * PageHeader). `null` until the bar has mounted; `undefined` outside the
 * signed-in shell (login, address portal), where a page has no bar and draws
 * its title inline instead.
 */
export const HeaderSlotContext = createContext<HTMLElement | null | undefined>(undefined);
